import React from 'react';
import PropTypes from 'prop-types';
import './StatusBadge.css';

const StatusBadge = ({ status, text }) => {
  const normalizedStatus = (status || '').toLowerCase();
  
  let modifier = 'default';
  if (['active', 'verified', 'approved'].includes(normalizedStatus)) {
    modifier = 'success';
  } else if (['pending', 'in_review'].includes(normalizedStatus)) {
    modifier = 'warning';
  } else if (['suspended', 'rejected', 'declined'].includes(normalizedStatus)) {
    modifier = 'danger';
  } else if (['draft'].includes(normalizedStatus)) {
    modifier = 'info';
  }

  return (
    <span className={`status-badge status-badge--${modifier}`}>
      {text || status}
    </span>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  text: PropTypes.string
};

export default StatusBadge;
